var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
export default function SimpleBackdrop() {
    return (_jsx("div", { children: _jsx(Backdrop, __assign({ sx: { color: "#fff", zIndex: 99999 }, open: true }, { children: _jsx(CircularProgress, { color: "inherit" }, void 0) }), void 0) }, void 0));
}
